import { Select } from "./Modal";
import { SUPPORTED_CURRENCIES } from "../../lib/currencies";

/**
 * Always sets currency_code and currency_precision together from one
 * selection — structurally impossible to get them out of sync, unlike the
 * free-text currency_code input this replaces (which had no precision
 * field at all, so every store silently kept currency_precision at
 * whatever it was created with).
 */
export function CurrencySelect({
  value,
  onChange,
}: {
  value: string;
  onChange: (code: string, precision: 0 | 2 | 3) => void;
}) {
  return (
    <Select
      value={value}
      onChange={(e) => {
        const opt = SUPPORTED_CURRENCIES.find((c) => c.code === e.target.value);
        if (opt) onChange(opt.code, opt.precision);
      }}
    >
      {SUPPORTED_CURRENCIES.map((c) => (
        <option key={c.code} value={c.code}>
          {c.label}
        </option>
      ))}
    </Select>
  );
}
